import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { CTA as CTAInterface } from 'types/campaign/collaborations'
import { isValidURL } from 'utils/helpers'


interface CTAProp {
    cta: CTAInterface,
    onChange: (cta: CTAInterface) => void
    onDelete?: () => void,
    onSave: () => void,
    viewOnly?: boolean
}

const CTA: React.FC<CTAProp> = ({ cta, onChange, onDelete, onSave, viewOnly }) => {
    const [editMode, setEditMode] = React.useState(false);
    const [errors, setErrors] = useState<Record<string, string>>({});

    useEffect(() => {
        if (cta.unsaved) {
            setEditMode(true);
        }
    }, [cta])

    const validateCTA = () => {
        let validation_errors: Record<string, string> = {}
        if (!cta.text) {
            validation_errors['text'] = 'Please enter CTA text';
        }
        if (cta.url && !isValidURL(cta.url)) {
            validation_errors['url'] = 'Please enter valid URL';
        }
        setErrors(validation_errors);
        return validation_errors;
    }

    const saveHandler = () => {
        let validation_errors = validateCTA();
        if (Object.values(validation_errors).length > 0) {
            return;
        }

        onSave();
        setEditMode(false);
    }
    return (
        <div>
            <Row className='mt-3'>
                <Col sm={12}>
                    {
                        editMode ? (
                            <div className='screening-question'>

                                <div className="form-group">
                                    <label htmlFor="screening-question">Text <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        value={cta.text}
                                        onChange={(e) => {
                                            onChange({ ...cta, text: e.target.value })
                                        }}
                                        onBlur={validateCTA}
                                        className="form-control"
                                    />
                                    {
                                        errors.text &&
                                        <span className="text-danger mt-2">{errors.text}</span>
                                    }
                                </div>
                                <div className="form-group mt-3">
                                    <label htmlFor="screening-question">URL</label>
                                    <input
                                        type="text"
                                        value={cta.url ?? ''}
                                        onChange={(e) => {
                                            onChange({ ...cta, url: e.target.value })
                                        }}
                                        onBlur={validateCTA}
                                        className="form-control"
                                    />
                                    {
                                        errors.url &&
                                        <span className="text-danger mt-2">{errors.url}</span>
                                    }
                                </div>
                                <div className="d-flex align-items-center justify-content-end mt-3 gap-2">
                                    <button className='btn btn-sm btn-outline-danger' onClick={onDelete}>Delete</button>
                                    <button disabled={Boolean(!cta.text || (cta.url && !isValidURL(cta.url)))} className='btn btn-sm btn-gradient' onClick={() => saveHandler()}>Save</button>
                                </div>
                            </div>

                        ) : (
                            <div className='screening-question'>
                                <div className='d-flex justify-content-between gap-3 align-items-center'>
                                    <div className='d-flex justify-content-between gap-3 align-items-center'>
                                        <div className="screening-question-icon">
                                            <i className='ri-check-line'></i>
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0'>{cta.text}</h5>
                                            <span className='screening-question-type'>
                                                {cta.url ? (<a href={cta.url} target="_blank" rel="noopener noreferrer">{cta.url}</a>) : 'No URL provided'}
                                            </span>
                                        </div>
                                    </div>
                                    {
                                        !viewOnly &&
                                        <div className='d-flex align-items-center justify-content-end gap-2'>
                                            <button className='unset-all' onClick={onDelete}>
                                                <span>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M19.3006 9.29883L17.5051 19.5115C17.3538 20.3723 16.6062 21 15.7324 21H8.4689C7.59505 21 6.84742 20.3723 6.6961 19.5115L4.90063 9.29883" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M20.2 6.60037H15.1375M4 6.60037H9.0625M9.0625 6.60037V4.80018C9.0625 3.80597 9.86839 3 10.8625 3H13.3375C14.3316 3 15.1375 3.80597 15.1375 4.80018V6.60037M9.0625 6.60037H15.1375" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                            <button className='unset-all text-primary' onClick={() => setEditMode(true)}>Edit</button>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    }
                </Col>
            </Row>
        </div>
    )
}

export default CTA
